// These request try blocks wrap far more than the network call, so a plain JS
// exception thrown after a successful response lands in the same catch. It has
// no `response`, so it used to be laundered into a fake
// {status:'500', message:'Something went wrong'} error page with the real error
// discarded -- no stack trace, and no matching server-side log to find.
//
// Passing the Error itself to console.error makes captureConsoleIntegration
// report it through captureException rather than captureMessage, which is what
// preserves the stack in Sentry.
//
// axios populates `request` for network/timeout failures but not for a bug in
// our own post-response code, so the two get distinct messages -- and therefore
// distinct Sentry fingerprints. A flaky connection should not bury a real bug.
export const reportNonHttpFailure = (context, error) => {
  if (error?.response) return;

  const kind = error?.request ? 'network' : 'client';
  console.error(`${context} failed (${kind}, no HTTP response)`, error);
};
